import React, { useState } from 'react';
import styles from './FAQComponent.module.css';
import Toxbox1 from '../../../../Images/newLandingPage/Toxbox1.png';
import faq from '../../../../Images/faq/faq.jpg'

const faqs = [
  {
    question: 'How quickly can I launch an agent?',
    answer: 'Most teams go live in under 30 minutes. Import your knowledge base, pick a voice, and connect a phone number.',
  },
  {
    question: 'Can agents integrate with my CRM?',
    answer: 'Yes. ToxBox AI supports native integrations with Salesforce, HubSpot, Zoho, and other major CRM platforms to keep your customer logs perfectly in sync.',
  },
  {
    question: 'How is pricing structured?',
    answer: 'Pricing is based on usage minutes. We offer transparent pricing structures with no hidden fees or per-seat costs, making it simple to scale up or down.',
  },
  {
    question: 'Is it secure and compliant?',
    answer: 'Absolutely. Security is our core priority. We support enterprise-grade encryptions and comply with SOC 2 Type II, HIPAA-ready, and GDPR requirements.',
  },
  {
    question: 'Do agents speak multiple languages?',
    answer: 'Yes, ToxBox AI voice agents support over 60+ languages with regional accents and dialects, allowing you to serve international markets effortlessly.',
  },

];

const FAQComponent = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className={styles.faqSection}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            Frequently asked <span className={styles.gradientText}>questions.</span>
          </h2>
          <p className={styles.subtitle}>Everything you need to know before you launch.</p>
        </div>

        <div className={styles.grid}>
          {/* Left Side: Illustrative widget */}
          <div className={styles.left}>
            <div className={styles.illustrationWrapper}>
              <img src={faq} alt="3D Agent Illustration" className={styles.avatarImg} />

              <div className={styles.supportButtonCard}>
                <div className={styles.supportIcon}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" fill="white" />
                  </svg>
                </div>
                <div className={styles.supportText}>
                  <h4>Still have questions?</h4>
                  <p>Chat with our team →</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side: Accordion list */}
          <div className={styles.right}>
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={index}
                  className={`${styles.faqItem} ${isOpen ? styles.active : ''}`}
                  onClick={() => toggleFAQ(index)}
                >
                  <div className={styles.question}>
                    <span>{faq.question}</span>
                    <span className={styles.icon}>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }}
                      >
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                    </span>
                  </div>
                  <div className={`${styles.answerWrapper} ${isOpen ? styles.open : ''}`}>
                    <div className={styles.answer}>
                      <p>{faq.answer}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQComponent;
